<template>
    <div class="landing">
        <NavbarComponent/>
        <div class="intro-text reveal" id="intro">
        <h1>Greo is upgrading <br> the conversation</h1>
        </div>
        <div class="start">
            <h3 class="start-text reveal" id="intro">explore</h3>
            <div class="start-indicator reveal" id="intro"></div>
        </div>
    </div>
</template>

<script>
import NavbarComponent from './Navbar.vue';

export default {
  name: 'LandingComponent',

  components: {
      NavbarComponent
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

@mixin breakpoint1 { @media only screen and (min-width: 0px) { @content; } }
@mixin breakpoint2 { @media only screen and (min-width: 750px) { @content; } }
@mixin breakpoint3 { @media only screen and (min-width: 1024px) { @content; } }

.landing {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.landing {
	@include breakpoint1 {
		padding: 2em;
		align-items: flex-start;
	}

	@include breakpoint2 {
		padding: 2em 3em;
		min-height: 60vh;
		align-items: center;
	}
}



.intro-text {
    display: flex;
    justify-content: center;
    align-items: center;
}

.intro-text {

	@include breakpoint1 {
		margin-top: 8vh;
	}

	@include breakpoint2 {
		min-height: 70vh;
	}
}



h1 {
    @include breakpoint1 {
        text-align: left;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        font-family: 'Mont-Heavy';
        font-size: calc(1rem + 4vw);
		margin: 0;
    }

    @include breakpoint2 {
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        font-family: 'Mont-Heavy';
        font-size: calc(1rem + 4vw);
    }
}

h3 {

	@include breakpoint1 {
		text-align: left;
		text-transform: uppercase;
		font-weight: 300;
		letter-spacing: 0.3em;
		opacity: 0.5;
    }

    @include breakpoint2 {
		text-align: center;
		text-transform: uppercase;
		font-weight: 300;
		letter-spacing: 0.3em;
		opacity: 0.5;
    }
}

h3:hover {
    opacity: 1.0;
    cursor: pointer;
}



.start-indicator {
    justify-content: center;
    align-items: center;
    margin: auto;
    background: linear-gradient(to bottom, white 50%, rgba(255, 255, 255, 0) 50%);
    animation: indicator;
    animation-duration: 2.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
}

.start-indicator {
	@include breakpoint1 {
		height: 0vh;
		visibility: hidden;
	}

	@include breakpoint2 {
		height: 20vh;
    	width: 1px;
		visibility: visible;

	}
}


// MARK: - Animations
@keyframes indicator {
    0% { 
        transform: translate3d(0px, 0px, 0px) scale(1,0); 
        transform-origin: center top 0px;
        animation-timing-function: cubic-bezier(0.9, 0, 1, 1);
         }
    64% { 
        transform: translate3d(0px, 0px, 0px) scale(1,1); 
        transform-origin: center top 0px;
        animation-timing-function: cubic-bezier(0, 0, 0.16, 1);
     }
    65% { 
        transform: translate3d(0px, 0px, 0px) scale(1,1);
        transform-origin: center center 0px;
        animation-timing-function: cubic-bezier(0, 0, 0.16, 1);

      }
    100% { 
        transform: translate3d(0px, 0px, 0px) scale(1,0);
        transform-origin: center center 0px;
        animation-timing-function: cubic-bezier(0.9, 0, 1, 1);
      }

}


</style>



// WEBPACK FOOTER //
// src/components/Intro/Landing.vue